/** biome-ignore-all lint/correctness/useExhaustiveDependencies: suppressed */
"use client";

import { Menu } from "lucide-react";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState } from "react";
import { Container } from "@/components/container";
import { Button } from "@/components/ui/button";
import {
	Sheet,
	SheetBody,
	SheetContent,
	SheetHeader,
	SheetTitle,
	SheetTrigger,
} from "@/components/ui/sheet";
import { useIsMobile } from "@/hooks/use-mobile";
import { useScrollPosition } from "@/hooks/use-scroll-position";
import { toAbsoluteUrl } from "@/lib/helpers";
import { cn } from "@/lib/utils";
import { UserDropdownMenu } from "@/partials/topbar/user-dropdown-menu";
import { Breadcrumb } from "./breadcrumb";
import { SidebarMenu } from "./sidebar-menu";

export function Header() {
	const [isSidebarSheetOpen, setIsSidebarSheetOpen] = useState(false);

	const pathname = usePathname();
	const mobileMode = useIsMobile();

	const scrollPosition = useScrollPosition();
	const headerSticky: boolean = scrollPosition > 0;

	// Close sheet when route changes
	useEffect(() => {
		setIsSidebarSheetOpen(false);
	}, [pathname]);

	return (
		<header
			className={cn(
				"header fixed top-0 z-10 flex items-stretch shrink-0 border-b bg-background end-0 pe-[var(--removed-body-scroll-bar-size,0px)]",
				headerSticky && "border-b border-border",
				mobileMode && "w-full",
			)}
		>
			<Container className="flex justify-between items-stretch lg:gap-4">
				<div className="flex gap lg:hidden items-center gap-2.5">
					<Link href="/" className="shrink-0">
						<Image
							src={toAbsoluteUrl("/media/app/logo-purple.png")}
							className="w-full"
							height={25}
							width={25}
							alt="mini-logo"
						/>
					</Link>
					<div className="flex items-center">
						{mobileMode && (
							<Sheet
								open={isSidebarSheetOpen}
								onOpenChange={setIsSidebarSheetOpen}
							>
								<SheetTrigger asChild>
									<Button variant="ghost" mode="icon">
										<Menu className="text-muted-foreground/70" />
									</Button>
								</SheetTrigger>
								<SheetContent
									className="p-0 gap-0 w-68.75"
									side="left"
									close={false}
								>
									<SheetHeader className="p-0 space-y-0">
										<SheetTitle className="sr-only">Navigation</SheetTitle>
									</SheetHeader>
									<SheetBody className="p-0 overflow-y-auto">
										<SidebarMenu />
									</SheetBody>
								</SheetContent>
							</Sheet>
						)}
					</div>
				</div>

				{!mobileMode && <Breadcrumb />}
				<div className="flex items-center gap-3 ml-auto">
					<UserDropdownMenu
						trigger={
							<Image
								height={36}
								width={36}
								className="rounded-full border-2 border-green-500 shrink-0 cursor-pointer object-cover size-9"
								src={
									"https://cdn.cazh.id/billing/profile/TVmcw9LPPoCsdSgGsHu4IPskqTNj3HOB7WjIOrsD.jpg"
								}
								alt="User"
							/>
						}
					/>
				</div>
			</Container>
		</header>
	);
}
